module.exports = __webpack_public_path__ + "img/illustrating-drawing.93f26003.svg";